<template>
	<div class="shpaddedit">
			
				<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Product':'Add Product'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit" class="editaddModel" no-close-on-backdrop>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
						<b-tabs content-class="mt-3" small v-model="tabIndex" class="mytabpae">
							<b-tab title="Product" href="#product" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3 mr-5">
											<!--<b-col cols="2" class="text-right">
											 <label class="font-sm">Product Title</label>  </b-col>-->
											<b-col >
											
											<!-- <b-form-input v-model="selectedItem.title" size="sm" :maxlength="100" required></b-form-input> -->
											
												<b-form-group label-for="title-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.title" invalid-feedback="Title is required!" label-cols-sm="3" content-cols-sm label="*Product Title" >
												<b-form-input id="title-input" :state="selectedItemState.title" v-model="selectedItem.title" @focusin="selectedItemState.title = null" size="sm"></b-form-input>
												</b-form-group>
											
											
											</b-col>
										</b-row>
										
										<b-row class="mb-3 mr-5">
											<b-col >
												<b-form-group label-for="product_tag-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.product_tag" invalid-feedback="Product Tag is required!" label-cols-sm="3" content-cols-sm label="Product Tag" >
												<b-form-input id="product_tag-input" :state="selectedItemState.product_tag" v-model="selectedItem.product_tag" @focusin="selectedItemState.product_tag = null" size="sm" placeholder="Should be comma (',') separated" ></b-form-input>
												</b-form-group>
											</b-col>
										</b-row>
										<b-row class="mb-3 mr-5">
											<!-- <b-col cols="2" class="text-right">
											<label class="font-sm">Short Description</label> </b-col>--> 
											<b-col>
												<!-- <b-form-textarea v-model="selectedItem.short_description" size="sm" rows="3" :maxlength="250" required></b-form-textarea>
												<small class="float-right">{{250-selectedItem.short_description.length}}/250 Character Remaining</small> -->	
												
												<b-form-group label-for="short_description-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.short_description" invalid-feedback="This is required!" label-cols-sm="3" content-cols-sm label="*Short Description" >
												<b-form-textarea id="short_description-input" :state="selectedItemState.short_description" v-model="selectedItem.short_description" @focusin="selectedItemState.short_description = null" size="sm" :maxlength="250" ></b-form-textarea>
												</b-form-group>
												<small class="float-right">{{250-selectedItem.short_description.length}}/250 Character Remaining</small>
												
											</b-col>
											
										</b-row>
										<b-row class="mb-3 mr-5">
											<!-- <b-col cols="2" class="text-right">
											<label class="font-sm">Description</label>  </b-col>-->
											<b-col>
												<!-- <b-form-textarea v-model="selectedItem.description" size="sm" rows="4" required></b-form-textarea> -->
												
												<b-form-group label-for="description-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.description" invalid-feedback="This is required!" label-cols-sm="3" content-cols-sm label="*Description" >
												<b-form-textarea id="description-input" :state="selectedItemState.description" v-model="selectedItem.description" @focusin="selectedItemState.description = null" size="sm"  ></b-form-textarea>
												</b-form-group>
												
												
												</b-col>
										</b-row>
										<b-row class="mb-3 mr-5">
											<!--<b-col cols="2" class="text-right">
											 <label class="font-sm">SKU</label>  </b-col>-->
											<b-col lg="8" md="12" sm="12">
											
												<!-- <b-form-input v-model="selectedItem.sku" required size="sm" placeholder="eq. 5"></b-form-input> -->
												<b-form-group label-for="sku-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.sku" invalid-feedback="Article No is required!" label-cols-sm="24" content-cols-sm label="*Article No" >
												<b-form-input id="sku-input" :state="selectedItemState.sku" v-model="selectedItem.sku" @focusin="selectedItemState.sku = null" size="sm"></b-form-input>
												</b-form-group>
											</b-col>
											<!--<b-col lg="4" md="12" sm="12">
											
												
												<b-form-group label-for="hsn-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.hsn_code" invalid-feedback="HSN is required!" label-cols-sm="3" content-cols-sm label="*HSN" >
												<b-form-input id="hsn-input" :state="selectedItemState.hsn_code" v-model="selectedItem.hsn_code" @focusin="selectedItemState.hsn_code = null" size="sm"></b-form-input>
												</b-form-group>
											</b-col> -->
											
										</b-row>
										<b-row class="mb-3 mr-5">
											<b-col lg="7" md="12" sm="12">
												<b-form-group label-for="gst_rate-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.gst_rate" invalid-feedback="GST Rate is required!" label-cols-sm="18" content-cols-sm label="*GST Rate (%)" >
												<b-form-input id="gst_rate-input" :state="selectedItemState.gst_rate" v-model="selectedItem.gst_rate" @focusin="selectedItemState.gst_rate = null" size="sm" class="ml-2"></b-form-input>
												</b-form-group> 
											</b-col>
										</b-row>
										<!--<b-row class="mb-3 mr-5">
											
											<b-col>
											
												
												<b-form-group label-for="hsn-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.hsn_code" invalid-feedback="HSN is required!" label-cols-sm="3" content-cols-sm label="*HSN" >
												<b-form-input id="hsn-input" :state="selectedItemState.hsn_code" v-model="selectedItem.hsn_code" @focusin="selectedItemState.hsn_code = null" size="sm"></b-form-input>
												</b-form-group>
											</b-col>
										</b-row> -->
										<b-row class="mb-3 mr-5">
											<!-- <b-col cols="2" class="text-right">
											
											<label class="font-sm">Category</label> </b-col>-->
											<b-col >
												<!-- <b-form-select v-model="selectedItem.category" :options="filteredCategory" size="sm" required></b-form-select> -->
												
												<b-form-group :state="selectedItemState.category"  label-for="category-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Category is required!" label-cols-sm="3" content-cols-sm label="*Category">
												
												<b-form-select v-model="selectedItem.category"   id="category-input" :state="selectedItemState.category" v-on:change="selectedItemState.category = null" size="sm" :options="filteredCategory" >
												</b-form-select>
												
											</b-form-group>
												
												<!-- <multiselect v-model="valueSelect" :options="optionsSel" :multiple="true"></multiselect> -->
												
												
								<!-- <label class="typo__label">Simple select / dropdown</label>
							  <multiselect v-model="valueSelect" :options="optionsSel" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
								<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
							  </multiselect> -->
							  <!-- pre class="language-json"><code>{{ valueSelect  }}</code></pre> -->
																					
											</b-col>
										</b-row>
										<b-row class="mb-3 mr-5">
											<!--<b-col cols="2" class="text-right">
												 <label class="font-sm">Product Type</label> 
												
												</b-col>-->
											<b-col lg="8" md="12" sm="12">
												
										<b-form-group :state="selectedItemState.product_type"  label-for="product_type-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="status is required!" label-cols-sm="49" content-cols-sm label="*Select Product Size">
										<b-form-select v-model="selectedItem.product_type" id="product_type-input" :state="selectedItemState.product_type" v-on:change="selectedItemState.product_type = null" size="sm">
										<b-form-select-option value="" hidden selected placeholder="select product_type">*Select Product Size</b-form-select-option>
										<b-form-select-option value="1">No Size</b-form-select-option>
										<b-form-select-option value="2">Sizes</b-form-select-option>
										</b-form-select>
										</b-form-group>
												
												
												
											</b-col>
											
											<b-col lg="4" md="12" sm="12">
											<b-form-group label-for="min_qty-input" label-size="sm" label-class="mb-2" class="mb-1" label-cols-sm="6" content-cols-sm label="Minimum Qty" >
											<b-form-input id="min_qty-input"  v-model="selectedItem.product_data.min_qty"  size="sm" placeholder="eq. 5" @keypress="onlyNumber" maxlength="2"></b-form-input>
											</b-form-group>
											</b-col>
										</b-row>
										<!--<b-row class="mb-3 mr-5">
											
											<b-col>
											<b-form-group label-for="min_qty-input" label-size="sm" label-class="mb-2" class="mb-1" label-cols-sm="3" content-cols-sm label="Minimum Qty" >
											<b-form-input id="min_qty-input"  v-model="selectedItem.product_data.min_qty"  size="sm" placeholder="eq. 5" @keypress="onlyNumber" maxlength="2"></b-form-input>
											</b-form-group>
											</b-col>
										</b-row>-->
									</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Sizes" v-if="selectedItem.product_type == 2" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'">
								<b-row class="mb-1">
									<b-col>
										<!-- {{JSON.stringify(sizelist)}} -->
										
										 <b-form-group label="Size:" v-slot="{ ariaDescribedby }">
										  <b-form-checkbox-group
											id="checkbox-group-2"
											v-model="selectedItem.selectedOption"
											:aria-describedby="ariaDescribedby"
											name="flavour-2"
										  >
											
											<b-form-checkbox size="sm" v-for="item in sizelist" v-bind:key="item.id" :value="item.attribute_value">{{item.attribute_value}}</b-form-checkbox>
											
											<!--
											<b-form-checkbox value="apple">Apple</b-form-checkbox>
											<b-form-checkbox value="pineapple">Pineapple</b-form-checkbox>
											<b-form-checkbox value="grape">Grape</b-form-checkbox> -->
										  </b-form-checkbox-group>
										</b-form-group>
										
										<!--{{selectedItem.selectedOption}} -->
									</b-col>
								</b-row>
							
								<!--<b-row class="mb-1">
									<b-col>
										<b-row class="mb-3">
											<b-col cols="6">
											</b-col>
											<b-col cols="6" class="text-right">
												<b-button size="sm" variant="danger" @click="addAttribute()" class="mr-2">Add Attribute</b-button>
												<b-button size="sm" variant="danger" @click="addVariation()" >Add Variation</b-button>
											</b-col>
										</b-row>
										<b-row no-gap>
											<b-col cols="2" class="px-1">
												<span class="font-sm p-2">SKU</span>
											</b-col>
											<b-col cols="2" class="px-1 mb-2" v-for="item in selectedItem.variation_attributes" :key="item">
												<b-form-input :value="item" required size="sm" placeholder="Attribute name"></b-form-input>
											</b-col>
											<b-col cols="1" class="px-1">
												<span class="font-sm p-2">Price</span>
											</b-col>
											<b-col cols="1" class="px-1">
												<span class="font-sm p-2">Sp.Price</span>
											</b-col>
											<b-col cols="1" class="px-1">
												<span class="font-sm p-2">Qty</span>
											</b-col>
											<b-col cols="1" class="px-1">
												<label class="font-sm">Delete</label>
											</b-col>
										</b-row>
										<b-row v-for="(item, index) in selectedItem.variations" :key="item.id" class="mb-2" no-gap>
											<b-col cols="2" class="px-1">
												<b-form-input v-model="item.sku" required size="sm"></b-form-input>
											</b-col>
											<b-col cols="2" class="px-1" v-for="attritem in item.attributes" :key="attritem.id" >
												<b-form-input v-model="attritem.value" required size="sm"></b-form-input>
											</b-col>
											<b-col cols="1" class="px-1">
												<b-form-input v-model="item.price" required size="sm" placeholder="0"></b-form-input>
											</b-col>
											<b-col cols="1" class="px-1">
												<b-form-input v-model="item.special_price" required size="sm" placeholder="0"></b-form-input>
											</b-col>
											<b-col cols="1" class="px-1">
												<b-form-input v-model="item.qty" required size="sm" placeholder="0"></b-form-input>
											</b-col>
											<b-col cols="1" class="px-1">
												<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="removeVariation(index)" size="sm"><b-icon scale="1.2" icon="trash" aria-hidden="true"></b-icon></b-button>
											</b-col>
										</b-row>
									</b-col>
								</b-row> -->
							</b-tab>
							<b-tab title="Stock" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'">
								<b-row class="mb-3">
									<!-- <b-col cols="2" class="text-left"><label class="font-sm">Stock Qty</label></b-col> -->
									<b-col lg="6" sm="12">
										<!-- <b-form-input v-model="selectedItem.stock_qty" required size="sm" placeholder="0"></b-form-input> -->
										
										<b-form-group label-for="stock_qty-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.stock_qty" invalid-feedback="Qty is required!" label-cols-sm="3" content-cols-sm label="*Stock Qty" >
												<b-form-input id="stock_qty-input" :state="selectedItemState.stock_qty" v-model="selectedItem.stock_qty" @focusin="selectedItemState.stock_qty = null" size="sm" placeholder="0" @keypress="onlyNumber"></b-form-input>
												</b-form-group>
										
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<!--<b-col cols="2" class="text-left"><label class="font-sm">Stock Status</label></b-col> -->
									<b-col lg="6" sm="12">
										<!-- <b-form-select v-model="selectedItem.stock_status" size="sm" required>
											<b-form-select-option value="1">In Stock</b-form-select-option>
											<b-form-select-option value="0">Out of stock</b-form-select-option>
										</b-form-select> -->
										
									<b-form-group :state="selectedItemState.stock_status"  label-for="stock_status-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Stock is required!" label-cols-sm="3" content-cols-sm label="*Stock Status">
										<b-form-select v-model="selectedItem.stock_status" id="status-input" :state="selectedItemState.stock_status" v-on:change="selectedItemState.stock_status = null" size="sm">
										<b-form-select-option value="" hidden selected placeholder="Stock">*Select Stock Status</b-form-select-option>
										<b-form-select-option value="1">In Stock</b-form-select-option>
										<b-form-select-option value="0">Out of stock</b-form-select-option>
										</b-form-select>
									</b-form-group>
										
										
										
									</b-col>
								</b-row>
							</b-tab>
							<!--<b-tab title="Size & Weight" to="#category" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											<b-col lg="3" sm="12"  class="text-right"><label >Size </label></b-col>
											<b-col lg="3" sm="12" class="flex-row mb-2"><span class="font-md pt-1 pr-1">Length:</span><b-form-input v-model="selectedItem.product_data.size_length" required size="sm"></b-form-input></b-col>
											<b-col lg="3" sm="12" class="flex-row mb-2"><span class="font-md pt-1 pr-1">Width:</span><b-form-input v-model="selectedItem.product_data.size_width" required size="sm"></b-form-input></b-col>
											<b-col lg="3" sm="12" class="flex-row "><span class="font-md pt-1 pr-1">Height:</span><b-form-input v-model="selectedItem.product_data.size_height" required size="sm"></b-form-input></b-col>
											
										</b-row>
										<b-row class="mb-3">
											<b-col lg="3" sm="12"  class="text-right"><label >&nbsp; </label></b-col>
											
											<b-col lg="3" sm="12" class="flex-row "><span class="font-md pt-1 pr-1">Weight:</span> <b-form-input v-model="selectedItem.product_data.weight" required size="sm"></b-form-input></b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-tab> -->
							<b-tab title="Images" to="#images" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											
											<b-col>
												Product Image
											</b-col>
											<b-col cols="2">
											Order By
											</b-col>
											<b-col cols="3">
												
											</b-col>
										</b-row>
										
									
										<b-row class="mb-3">
											
											<b-col>
												<!--<b-form-file type="file" v-model="product_inf.product_image_1" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file> -->
												
												<b-form-group label-for="product_image_1-input" label-size="sm" label-class="mb-2" class="mb-1" :state="product_infState.product_image_1" invalid-feedback="Image is required!" >
											
													
													<b-form-file type="file" v-model="product_inf.product_image_1" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image" id="product_image_1-input" :state="product_infState.product_image_1" @focusin="product_infState.product_image_1 = null" ></b-form-file>
												</b-form-group>
												
												<b-form-text v-if="selectedItem.gallery_images[0]!=''">
												<span v-if="deleteImage1!=1">
												{{selectedItem.gallery_images[0]}}
												<b-link @click="product_inf.product_image_1='',selectedItem.gallery_images[0]='',deleteImage1=1"> <i aria-hidden="true" class="fa fa-trash" v-b-tooltip.hover title="Delete Image" placement="bottom"></i></b-link>
												</span>
												</b-form-text>
											</b-col>
											<b-col cols="2">   
												<b-form-group label-size="sm" label-class="mb-2" class="mb-1"  label-cols-sm="3" content-cols-sm  >
												<b-form-input v-model="product_inforder.order_1"  size="sm" @keypress="imageOrderVAlidate" @keyup="imageOrderVAlidateP" min="1" maxlength="1"></b-form-input> 
												</b-form-group>
											</b-col>
											<b-col cols="3" class="text-right" >
												<b-img  v-if="selectedItem.gallery_images[0]!=''" v-bind="thumbnailProps" rounded alt="" :src="selectedItem.gallery_images[0]"></b-img>
											
											</b-col>
										</b-row>
										<b-row class="mb-3">
											
											<b-col>
												<b-form-file type="file" v-model="product_inf.product_image_2" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
												<b-form-text  v-if="selectedItem.gallery_images[1]!=''">
												<span v-if="deleteImage2!=1">
												{{selectedItem.gallery_images[1]}}
												
												<b-link @click="product_inf.product_image_2='',selectedItem.gallery_images[1]='',deleteImage2=1"> <i aria-hidden="true" class="fa fa-trash" v-b-tooltip.hover title="Delete Image" placement="bottom"></i></b-link>
												</span>
												</b-form-text>
											</b-col>
											<b-col cols="2">   
												<b-form-group label-size="sm" label-class="mb-2" class="mb-1"  label-cols-sm="3" content-cols-sm  >
												<b-form-input v-model="product_inforder.order_2"  size="sm" @keypress="imageOrderVAlidate" @keyup="imageOrderVAlidateP" min="1" maxlength="1"></b-form-input>
												</b-form-group>
											</b-col>
											<b-col cols="3" class="text-right d-none d-md-block">
												<b-img  v-if="selectedItem.gallery_images[1]!=''" v-bind="thumbnailProps" rounded alt="" :src="selectedItem.gallery_images[1]"></b-img>
											</b-col>
										</b-row>
										<b-row class="mb-3">
										
											<b-col>
												<b-form-file type="file" v-model="product_inf.product_image_3" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
												<b-form-text v-if="selectedItem.gallery_images[2]!=''">
												<span v-if="deleteImage3!=1">
												{{selectedItem.gallery_images[2]}}
												
													<b-link @click="product_inf.product_image_3='',selectedItem.gallery_images[2]='',deleteImage3=1"> <i aria-hidden="true" class="fa fa-trash" v-b-tooltip.hover title="Delete Image" placement="bottom"></i></b-link>
													</span>
													</b-form-text>
											</b-col>
											<b-col cols="2">   
												<b-form-group label-size="sm" label-class="mb-2" class="mb-1"  label-cols-sm="3" content-cols-sm  >
												<b-form-input v-model="product_inforder.order_3"  size="sm" @keypress="imageOrderVAlidate" @keyup="imageOrderVAlidateP" min="1" maxlength="1"></b-form-input>
												</b-form-group>
											</b-col>
											<b-col cols="3" class="text-right d-none d-md-block">
											
												<b-img  v-if="selectedItem.gallery_images[2]!=''" v-bind="thumbnailProps" rounded alt="" :src="selectedItem.gallery_images[2]"></b-img>
											</b-col>
										</b-row>
										<b-row class="mb-3">
											
											<b-col>
												<b-form-file type="file" v-model="product_inf.product_image_4" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
												<b-form-text v-if="selectedItem.gallery_images[3]!=''">
												<span v-if="deleteImage4!=1">												{{selectedItem.gallery_images[3]}}											
												<b-link @click="product_inf.product_image_4='',selectedItem.gallery_images[3]='',deleteImage4=1"> <i aria-hidden="true" class="fa fa-trash" v-b-tooltip.hover title="Delete Image" placement="bottom"></i></b-link> 
												</span>
												</b-form-text>
											</b-col>
											<b-col cols="2">   
												<b-form-group label-size="sm" label-class="mb-2" class="mb-1"  label-cols-sm="3" content-cols-sm  >
												<b-form-input v-model="product_inforder.order_4"  size="sm" @keypress="imageOrderVAlidate" @keyup="imageOrderVAlidateP" min="1" maxlength="1"></b-form-input>
												</b-form-group>
											</b-col>
											<b-col cols="3" class="text-right d-none d-md-block">
												<b-img  v-if="selectedItem.gallery_images[3]!=''" v-bind="thumbnailProps" rounded alt="" :src="selectedItem.gallery_images[3]"></b-img>
											</b-col>
											
										</b-row>
										
										<b-row class="mb-3">
											
											<b-col>
												<b-form-file type="file" v-model="product_inf.product_image_5" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
												<b-form-text v-if="selectedItem.gallery_images[4]!=''">
												<span v-if="deleteImage5!=1">
												{{selectedItem.gallery_images[4]}}
												
												<b-link @click="product_inf.product_image_5='',selectedItem.gallery_images[4]='',deleteImage5=1"> <i aria-hidden="true" class="fa fa-trash" v-b-tooltip.hover title="Delete Image" placement="bottom"></i></b-link> 
												</span>
												</b-form-text>
											</b-col>
											<b-col cols="2">   
												<b-form-group label-size="sm" label-class="mb-2" class="mb-1"  label-cols-sm="3" content-cols-sm  >
												<b-form-input v-model="product_inforder.order_5"  size="sm" @keypress="imageOrderVAlidate" @keyup="imageOrderVAlidateP" min="1" maxlength="1"></b-form-input>
												</b-form-group>
											</b-col>
											<b-col cols="3" class="text-right d-none d-md-block">
											
												<b-img  v-if="selectedItem.gallery_images[4]!=''" v-bind="thumbnailProps" rounded alt="" :src="selectedItem.gallery_images[4]"></b-img>
											</b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Price" to="#price" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											<!--<b-col cols="3" class="text-right"><label class="font-sm">Price</label></b-col> -->
											<b-col lg="6" sm="12">
												<!--<b-form-input v-model="selectedItem.price" required size="sm" placeholder="eq. 19.99" @keypress="onlyRupees"></b-form-input> -->
												
													<b-form-group label-for="price-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.price" invalid-feedback="Price is required!" label-cols-sm="3" content-cols-sm label="*Price" >
													<b-form-input id="price-input" :state="selectedItemState.price" v-model="selectedItem.price" @focusin="selectedItemState.price = null" size="sm" placeholder="eq. 19.99" @keypress="onlyRupees" ></b-form-input>
													</b-form-group>



											</b-col>
										</b-row>
										<b-row class="mb-3">
											<!--<b-col cols="3" class="text-right"><label class="font-sm">Discount (</label></b-col -->
											<b-col lg="6" sm="12">
												<!--<b-col><b-form-input v-model="selectedItem.discount" required size="sm" placeholder="eq. 10%" @keypress="onlyRupees"></b-form-input></b-col> -->
												
												
												<b-form-group label-for="discount-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.discount" invalid-feedback="Discount is required!" label-cols-sm="3" content-cols-sm label="Discount" >
													<b-form-input id="discount-input" :state="selectedItemState.discount" v-model="selectedItem.discount" @focusin="selectedItemState.discount = null" size="sm" placeholder="eq. 10%" @keypress="onlyRupees" ></b-form-input>
													</b-form-group> 
												
											</b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Special Price</label></b-col>
											<label v-if="selectedItem.discount > 0">
											{{this.$root.currency() + $root.tofixed(selectedItem.price -((selectedItem.price*selectedItem.discount)/100) || 0,2)}}
											<!-- {{$root.tofixed(selectedItem.price-((selectedItem.price*selectedItem.discount)/100)), 2)}}% -->
											
											</label>
											<label v-else>{{this.$root.currency()}}0.00</label>
										</b-row>
										
									</b-col>
								</b-row>
							</b-tab>
							<!--<b-tab title="Tier Price" href="#product" disabled> 
								<b-row class="mb-1">
									<b-col cols="2">
									</b-col>
									<b-col cols="7">
										<b-row>
											<b-col>
												<b-row>
													<b-col cols="2">
														<label class="font-sm">S.No.</label>
													</b-col>
													<b-col cols="3">
														<label class="font-sm">Min. Qty</label>
													</b-col>
													<b-col cols="3">
														<label class="font-sm">Price</label>
													</b-col>
													<b-col cols="3">
														<label class="font-sm">Discount</label>
													</b-col>
													<b-col cols="1">
														<label class="font-sm">Delete</label>
													</b-col>
												</b-row>
												<b-row v-for="(item, index) in selectedItem.tier_price" :key="item.id" class="mb-2">
													<b-col cols="2">
														<label class="font-sm">{{index+1}}</label>
													</b-col>
													<b-col cols="3">
														<b-form-input v-model="item.min_qty" required size="sm" placeholder="0"></b-form-input>
													</b-col>
													<b-col cols="3">
														<b-form-input v-model="item.price" required size="sm" placeholder="0.00"></b-form-input>
													</b-col>
													<b-col cols="3">
														<b-form-input required size="sm" :value="$root.tofixed((selectedItem.price - (item.price/item.min_qty))/selectedItem.price * 100, 2)+' %'" disabled></b-form-input>
													</b-col>
													<b-col cols="1">
														<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="removeTierPrice(index)" size="sm"><b-icon scale="1.2" icon="trash" aria-hidden="true"></b-icon></b-button>
													</b-col>
												</b-row>
											</b-col>
										</b-row>
									</b-col>
									<b-col cols="3"><b-button size="sm" variant="danger" @click="addTierPrice()" class="float-right">Add Tier Price</b-button></b-col>
								</b-row>
							</b-tab> -->
							<b-tab title="Commission" href="#product" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											<!-- <b-col cols="3" class="text-right"><label class="font-sm">Sales Commission</label></b-col> -->
											<b-col>
												<!-- <b-form-input v-model="selectedItem.commission" type="number" required size="sm" placeholder="0" min="0" @keyup="onChangeCommission()"></b-form-input> -->
												
												
												
												
												<b-form-group label-for="commission-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedItemState.commission" :invalid-feedback="commissionError" label-cols-sm="3" content-cols-sm label="*Sales Commission" >
												
												<!--<b-form-input id="title-input" :state="selectedItemState.title" v-model="selectedItem.title" @focusin="selectedItemState.title = null" size="sm"></b-form-input> -->
												
												<b-form-input id="commission-input" :state="selectedItemState.commission" v-model="selectedItem.commission" type="number" @focusin="selectedItemState.commission = null" size="sm" placeholder="0" min="0" @keyup="onChangeCommission()"></b-form-input>
												<small>Min recommended is 10%. To boost sales you can increase commission based on your margins..</small>
												</b-form-group>


												
											</b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Web Charges</label></b-col>
											<b-col>
												<b-form-input required size="sm" value="5 %" disabled></b-form-input>
												<small>Fixed 5%</small>
											</b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Total Commission</label></b-col>
											<b-col>
												<b-form-input v-if="selectedItem.commission > 0" required size="sm" disabled :value="(parseFloat(selectedItem.commission) + 5)+' %'"></b-form-input>
												<b-form-input v-else required size="sm" disabled value="10 %"></b-form-input>
												<small>Min commission 10%</small>
											</b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Brand" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'" >
								<b-row class="mb-3">
									<!-- <b-col cols="3" class="text-right"><label class="font-sm">Brand </label></b-col> -->
									<b-col lg="6" sm="12">
										<!-- <b-form-select v-model="selectedItem.brand" size="sm">
											<b-form-select-option v-for="option in brandlist" :key="option.id" :value="option.brand_name">{{option.brand_name}}</b-form-select-option>
											
										</b-form-select> -->
										
										
										<b-form-group :state="selectedItemState.brand"  label-for="brand-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Brand is required!" label-cols-sm="3" content-cols-sm label="*Brand">
										<b-form-select v-model="selectedItem.brand" id="status-input" :state="selectedItemState.brand" v-on:change="selectedItemState.brand = null" size="sm">
										<b-form-select-option value="" hidden selected placeholder="Brand">*Select Brand</b-form-select-option>
										<b-form-select-option v-for="option in brandlist" :key="option.id" :value="option.brand_name">{{option.brand_name}}</b-form-select-option>
										</b-form-select>
									</b-form-group>
										
										
									</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Info" :title-item-class="(selectedItem.id > 0)?'':'disabledTab'">
									<b-row class="mb-1">
										<b-col cols="12">
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">How to use</label></b-col>
											<b-col>
												<b-form-textarea v-model="selectedItem.how_to_use" size="sm" rows="3" :maxlength="250"></b-form-textarea>
												
											</b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Ingredients</label></b-col>
											<b-col>
												<b-form-textarea v-model="selectedItem.ingredients" size="sm" rows="3" :maxlength="250"></b-form-textarea>
												
											</b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Dimension</label></b-col>
											<b-col>
												<b-form-textarea v-model="selectedItem.dimension" size="sm" rows="2" :maxlength="250" ></b-form-textarea>
											</b-col>
										</b-row>
										
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Ideal For <small>(Gender)</small></label></b-col>
											<b-col cols="4">
												<b-form-select v-model="selectedItem.gender" size="sm">
													 <b-form-select-option v-for="item in $root.gender_list" v-bind:key="item.id" :value="item.slug">{{item.label}}</b-form-select-option>
													<!-- <b-form-select-option value="male">Male</b-form-select-option>
													<b-form-select-option value="female">Female</b-form-select-option>
													<b-form-select-option value="unisex">Unisex</b-form-select-option> -->
												</b-form-select>
												
											</b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Country of Origin</label></b-col>
											<b-col cols="4">
												<b-form-select v-model="selectedItem.country_origin" size="sm">
												 <b-form-select-option v-for="item in $root.country_origin" v-bind:key="item.id" :value="item.slug">{{item.label}}</b-form-select-option>
													 <!--<b-form-select-option value="India">India</b-form-select-option>
													 <b-form-select-option value="China">China</b-form-select-option> -->
													 
												</b-form-select>
											</b-col>
										</b-row>
										
										
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Expiry Date</label></b-col>
											<b-col cols="4">
											
												<b-form-group label-for="expiry_date-input"  content-cols-sm  >
													<b-form-input id="expiry_date-input"  v-model="selectedItem.expiry_date"  size="sm" ></b-form-input>
											</b-form-group>
												
											</b-col>
										</b-row>
										
											
										</b-col>
									</b-row>
								</b-tab>

						</b-tabs>
						
					</b-container>
				</form>
				<template  v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()" style="display:none;">Cancel</b-button>
					<!-- <b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button> -->
					
					<p v-if="selectedItem.id==0">
						<!-- {{ tabIndex }}
						{{selectedItem.product_type}} -->
						<span v-if="selectedItem.product_type==1"> 
						
						  <b-button-group  size="sm" class="mr-2">
							<b-button v-if="tabIndex>0" @click="tabIndex--" size="sm" class="mr-2">Previous</b-button>
							<b-button v-if="tabIndex<6" @click="checkFormValidityBank
							()" size="sm" >Next</b-button>
						  </b-button-group> 
						
						
							<b-button size="sm" v-if="tabIndex==6 " variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
						</span>
						<span v-else>
							<b-button-group  size="sm" class="mr-2">
							<b-button v-if="tabIndex>0" @click="tabIndex--" size="sm" class="mr-2">Previous</b-button>
							<b-button v-if="tabIndex<7" @click="checkFormValidityBank()" size="sm" >Next</b-button>
						  </b-button-group> 
						
						
						<b-button size="sm" v-if="tabIndex==7" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
						</span>
						</p>
						<p v-else>
							<b-button size="sm mr-2" variant="danger" @click="close()" >Cancel</b-button> 
							<b-button size="sm"  variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
								
						</p>
				</template>
				
			</b-modal>



	</div>		
</template>
<script>

/* setpassword

http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";

export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  
  },
  props: { 
	selectedItem: { type: Object },	
	filteredCategory: { type: Array },	
	category: { type: Array },	
	brandlist: { type: Array },	
	sizelist: { type: Array },	
  },
  mounted(){
    this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
			//loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },           
			product_inf: {},
			product_infState: {product_image_1:null,
						  product_image_2:null,
						  product_image_3:null,
						  product_image_4:null,
						  product_image_5:null,
						  },
			product_inforder: {
					order_1:1,
					order_2:2,
					order_3:3,
					order_4:4,
					order_5:5},
		updateUrl: this.$root.WEBAPI+'secureapi/productstatus-update',
		updateProUrl: this.$root.NEWAPIURL+'sellerapi/productupdatenew',
		insertnewUrl: this.$root.NEWAPIURL+'sellerapi/productinsertnew',
		 /*selectedItem: {
				title: '',
				short_description: '',
				description: '',
				sku: '',
				hsn_code: '',
				gst_rate: '',
				category: '',
				price: '',
				discount: '',
				product_type:1,
				stock_qty:'',
				stock_status:'',
				product_data:{}, 
				tier_price:[], 
				gallery_images:["","","",""],
				status:'',
				commission:'',
				variation_attributes:[],
				variations:[],
				brand:'',
			},*/
			selectedItemState: {
				title: null,
				short_description: null,
				description:null,
				sku: null,
				hsn_code: null,
				gst_rate: null,
				category: null,
				price: null,
				discount: null,
				product_type: null,
				stock_qty:null,
				stock_status:null,
				product_data:{}, 
				tier_price:null, 
				status:null,
				commission:null,
				variation_attributes:null,
				variations:null,
				brand:null,
				country_origin:null,
				expiry_date:null,
			},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				hsn_code: '',
				gst_rate: '',
				category: '',
				price: '',
				product_type: 1,
				stock_qty:'',
				stock_status:'',
				special_price: '',
				product_data:{},
				tier_price: [],
				gallery_images:["","","","",""],
                status: 0,
                commission: '',
				variation_attributes:[],
				variations:[],
				brand:'',
				country_origin:'India',
				expiry_date:'',
				selectedOption:[]
			},
			counterindex:1,
			deleteImage1:'',
			deleteImage2:'',
			deleteImage3:'',
			deleteImage4:'',
			deleteImage5:'',
			tabIndex: 0,
			commissionError:'Commission is required!',
			selectMode: 'multi',
			selected: [],
			sellerList: [],
			reg_brand:null,
			valueSelect:[],
			optionsSel:[],
		
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
		},
		checkFormValidityBank() {
			//alert('tab');
			var step2=0;
			var step3=0;
			var step4=0;
			var step6=0;
			var step7=0;
			if(this.selectedItem.product_type==2){
				step2 =2;
				step3 =3;
				step4=4;
				step6=5;
				step7=6;
			}else{
				step2 =1;
				step3 =2;
				step4=3;
				step6=4;
				step7=5;
				
			}
			
			if(this.tabIndex==0){
					var valid = true;
					if(this.selectedItem.title.length < 3){
					valid = false;
					this.selectedItemState.title = false;
					}else{
					this.selectedItemState.title= true;
					}
					
					if(this.selectedItem.short_description.length < 3){
					valid = false;
					this.selectedItemState.short_description = false;
					}else{
					this.selectedItemState.short_description= true;
					}
					
					if(this.selectedItem.description.length < 3){
					valid = false;
					this.selectedItemState.description = false;
					}else{
					this.selectedItemState.description= true;
					}
					
					if(this.selectedItem.sku.length < 4){
					valid = false;
					this.selectedItemState.sku = false;
					}else{
					this.selectedItemState.sku= true;
					}
					if(this.selectedItem.hsn_code==''){
					valid = false;
					this.selectedItemState.hsn_code = false;
					}else if(this.selectedItem.hsn_code.length < 4){
					valid = false;
					this.selectedItemState.hsn_code = false;
					}else{
					this.selectedItemState.hsn_code= true;
					}
					
					if(this.selectedItem.category.length < 1){
					valid = false;
					this.selectedItemState.category = false;
					}else{
					this.selectedItemState.category= true;
					}
					
					
					
					/*if(this.selectedItem.product_type==''){
					valid = false;
					this.selectedItemState.product_type = false;
					}else{
					this.selectedItemState.product_type= true;
					} */
					
					if(this.selectedItem.product_type==''){
					valid = false;
					this.selectedItemState.product_type = false;
					}else{
					this.selectedItemState.product_type= true;
					}
					if(valid){
						//tabIndex++;
						this.tabIndex=Number(this.tabIndex)+1;
					}
					
				}else if(this.tabIndex==step2){
					var valid2 = true;
					//console.log(this.selectedItem.stock_status);
					if(this.selectedItem.stock_qty==''){
					valid2 = false;
					this.selectedItemState.stock_qty = false;
					}else{
					this.selectedItemState.stock_qty= true;
					}
					
					if(this.selectedItem.stock_status==''){
					valid2 = false;
					this.selectedItemState.stock_status = false;
					}else{
					this.selectedItemState.stock_status= true;
					}
					
					if(valid2){
						//tabIndex++;
						this.tabIndex=Number(this.tabIndex)+1;
					}
				
				
				}else if(this.tabIndex==step3){
					var valid3 = true;
					//console.log(this.product_inf.product_image_1);
					if(this.selectedItem.gallery_images[0]==''){
						if(typeof this.product_inf.product_image_1==='undefined'){
						valid3 = false; 
							this.product_infState.product_image_1 = false;
						}else{
							this.product_infState.product_image_1= true;
						}
					}
					if(valid3){
						//tabIndex++;
						this.tabIndex=Number(this.tabIndex)+1;
					}
				}else if(this.tabIndex==step4){
					console.log(this.selectedItem.stock_status);
					var valid4 = true;
					if(this.selectedItem.price==''){
					valid4 = false;
					this.selectedItemState.price = false;
					}else{
					this.selectedItemState.price= true;
					}
					if(valid4){
						//tabIndex++;
						this.tabIndex=Number(this.tabIndex)+1;
					}
					
				}else if(this.tabIndex==step6){
					console.log(this.selectedItem.commission);
					var valid6 = true;
					if(this.selectedItem.commission==''){
						valid6 = false;
						//this.commissionError='Min commission 5%!';
						this.selectedItemState.commission = false;
					}
					else if(this.selectedItem.commission<5){
					valid6 = false;
					this.commissionError='Min commission should be 5%!';
					this.selectedItemState.commission = false;
					}else{
					this.selectedItemState.commission= true;
					}
					if(valid6){
						//tabIndex++;
						this.tabIndex=Number(this.tabIndex)+1;
					}
					
				}else if(this.tabIndex==step7){
					console.log(this.selectedItem.brand);
					var valid7 = true;
					if(this.selectedItem.brand==''){
					valid7 = false;
					this.selectedItemState.brand = false;
					}else{
					this.selectedItemState.brand= true;
					}
					if(valid7){
						//tabIndex++;
						this.tabIndex=Number(this.tabIndex)+1;
					}
					
				}else{
					this.tabIndex=Number(this.tabIndex)+1;
				}
				
				
				
			//return valid;
	},

			modalSubmit(bvModalEvt){
					/* if (!this.checkFormValidityBank()) {
						return;
						} */
					var self = this;
					self.loading = true;
					bvModalEvt.preventDefault();
					var submitUrl = "";
					var editAct=0;
					if(self.selectedItem.id == 0){
						submitUrl = self.insertnewUrl;
					}else{
						submitUrl = self.updateProUrl;
						editAct=1;
					} 

					let formData = new FormData();
					formData.append('imagefile1', this.product_inf.product_image_1);
					formData.append('imagefile2', this.product_inf.product_image_2);
					formData.append('imagefile3', this.product_inf.product_image_3);
					formData.append('imagefile4', this.product_inf.product_image_4);
					formData.append('imagefile5', this.product_inf.product_image_5);
					
					//formData.append('image_order', this.product_inforder);
					this.selectedItem.image_order = this.product_inforder;
					formData.append('data', JSON.stringify(this.selectedItem));
					formData.append('accesskey', this.$session.get('access_key'));

					self.axios.post(submitUrl, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							
							self.$bvToast.toast(response.data.message, {
								title: 'Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							if(editAct==0){
							self.$bvModal.hide('my-model');
							
							self.product_inf.product_image_1 = '';
							self.product_inf.product_image_2 = '';
							self.product_inf.product_image_3 = '';
							self.product_inf.product_image_4 = '';
							self.product_inf.product_image_5 = '';
							//self.initload();
							}
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
		},
		resetSelectedItem(){
			//var self = this;
			//self.selectedItem = Object.assign({}, self.emptyItem);
		},
		onlyRupees ($event) {
		   //console.log($event.keyCode); //keyCodes value
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
			  $event.preventDefault();
		   }
		},
		onlyNumber ($event) {
		   //console.log($event.keyCode); //keyCodes value
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }
		},
		imageOrderVAlidate($event) {
		   //console.log($event.keyCode); //keyCodes value
		  // console.log($event.target.value); //keyCodes value
		   
		    /*let regex = /^[0-9]*$/
			  if (!regex.test(el.value)) {
				el.value = el.value.slice(0, -1)
			  }*/
		   
		   
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }
		},
		imageOrderVAlidateP($event) {
		   console.log($event.keyCode); //keyCodes value
		   console.log($event.target.value); //keyCodes value
		   
		    let regex = /^[1-5]*$/
			  if (!regex.test($event.target.value)) {
				$event.target.value = $event.target.value.slice(0, -1);
			  }
		   
		   /*
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }*/
		},onChangeCommission(){
			if(this.selectedItem.commission < 5 && this.selectedItem.commission != 0){
				//this.selectedItem.commission = 5;
			}
		},filterChildCategory(id, index, parentid){
			var self = this;
			var tab = '';
			for (let i = 0; i < index; i++) {
				tab += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
			}
			this.category.forEach(function(field){
				if(field.parent == id){
					var fieldid = field.id;
					if(parentid != 0){
						fieldid = parentid+','+field.id;
					}
					self.filteredCategory.push({ html: tab+field.title, title:field.title, position:field.position, parent:field.parent, value: fieldid });
					
					self.optionsSel.push({ name: tab+field.title, language:field.title,value: fieldid});
					
					self.filterChildCategory(field.id, index+1, fieldid);
				}
			});
			return ;
		},
		addVariation(){
			//console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			var uniqid = d.getTime();
			var attributes = [];
			this.selectedItem.variation_attributes.forEach(function(attr){
				attributes.push({'id':++uniqid, 'label':attr, 'value': '', position: ''});
			});
			this.selectedItem.variations.push({'id':d.getTime(), 'sku':'', 'attributes':attributes, 'price': 0, 'special_price': 0, 'stock_qty': 1, 'stock_status': 1});
		},
		addAttribute(){
			var d = new Date();
			if(this.selectedItem.variation_attributes.length < 3){
				this.selectedItem.variation_attributes.push("");
				this.selectedItem.variations.forEach(function(variation){
					variation.attributes.push({"id":d.getTime(),"label":"","value":"","position":variation.attributes.length+1});
				});
			}
		},
		

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">
	
	.disabledTab{
      pointer-events: none;
	}
	.mytabpae{
		/*border:1px solid red;*/
		.nav-link{
		font-size:11px !important;
		}
	}
	.modal-body{
		padding-bottom: 0px;
	}
	.modal-header{
				padding-top:3px !important;
				padding-bottom:3px !important;
			}
			
	.modal-footer{		
			padding-top: 2px;
			padding-bottom: 3px;
			padding-right: 10%;
	}
	.editaddModel{
			
	}
	.col-sm-18{
	margin-right:18%;
	}.col-sm-24{
	margin-right:21%;
	}.col-sm-48{
	margin-right: 29%;
	}.col-sm-49{
	margin-right: 7%;
	}
	
	
	


</style>
